import React from 'react';
import lodash from 'lodash';
import ObjectUtils from '../../../../../modules/ObjectUtils';
import GrIntegrationService from '../../../../../service/GrIntegrationService';
import SearchBar from '../../../../searchbar/SearchBar';
import FieldSet from '../../../../fieldset/FieldSet';
import Grid from '../../../../grid/Grid';
import AccountLinkForm from '../../../../form/AccountLinkForm';
import PrepaidAccountForm from '../../../../form/PrepaidAccountForm';
import RefuseAccountServiceAddressesForm from '../../../../form/RefuseAccountServiceAddressesForm';

class GRRefuse extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.comboFields = [
      {
        value: 'externalAccountId',
        display: 'External Account ID',
      },
      {
        value: 'customerId',
        display: 'Customer ID',
      },
    ];
  }

  SERVICE_OFFERING_ID = 'gr_refuse';

  onAccountRowSelect(selectedRow) {
    const { accountRows, } = this.state;
    const account = accountRows.find((row) => {
      const { raw, } = row;
      return raw._id === selectedRow._id;
    });
    this.setState({
      selectedAccount: account.raw,
    });
  }

  getAccounts(event) {
    this.reset();
    const { combo, search, } = event;
    const criteria = {};
    criteria[combo.value] = search.value;
    const headers = [];
    const rows = [];

    GrIntegrationService.getGrRefuseAccountsBySearchCriteria(criteria)
      .then((response) => {
        const { accounts, } = response.data;

        if (accounts && accounts.length > 0) {
          const exclusions = value => ![ 'customerIds', ].includes(value);
          const formattedAccounts = accounts.map((account) => {
            const copy = { ...account, };
            copy.customerIds = ObjectUtils.formatStringAsJSONArray(copy.customerIds);
            copy.serviceAddresses = ObjectUtils.formatStringAsJSONArray(copy.serviceAddresses);
            return ObjectUtils.filterObject(copy, exclusions);
          });

          ObjectUtils.toLargestKeySet(formattedAccounts.map(v => v.value)).forEach((key) => {
            const value = {
              display: lodash.startCase(key),
              value: key,
            };
            headers.push(value);
          });

          formattedAccounts.forEach((account) => {
            rows.push({
              value: Object.values(account.value),
              raw: account.raw,
            });
          });
        }
        this.setState({
          accountHeaders: headers,
          accountRows: rows,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  reset() {
    this.setState({
      selectedAccount: undefined,
      accountRows: [],
      accountHeaders: [],
    });
  }

  showAccountFooter(selectedAccount) {
    if (!selectedAccount) {
      return null;
    }

    return (
      <div className="container">
        <p>{`Selected ID: ${selectedAccount._id}`}</p>
        <div className="row">
          <div className="m-1">
            <AccountLinkForm
              customerIds={selectedAccount.customerIds}
              id={selectedAccount.id}
              serviceOfferingId={this.SERVICE_OFFERING_ID}
            />
          </div>
          <div className="m-1">
            <PrepaidAccountForm
              serviceOfferingId={this.SERVICE_OFFERING_ID}
              externalAccountId={selectedAccount.externalAccountId}
            />
          </div>
          <div className="m-1">
            <RefuseAccountServiceAddressesForm
              {...selectedAccount}
              serviceOfferingId={this.SERVICE_OFFERING_ID}
              title={`Service Addresses for Account ${selectedAccount.externalAccountId}`}
              accountId={selectedAccount._id}
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { selectedAccount, accountHeaders = [], accountRows = [], } = this.state;

    return (
      <div className="container">
        <SearchBar comboFields={this.comboFields} onClick={event => this.getAccounts(event)} />
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="Refuse Accounts" style={{ maxHeight: '300px', }}>
            <Grid
              headers={accountHeaders}
              rows={accountRows}
              onRowSelect={row => this.onAccountRowSelect(row)}
            />
          </FieldSet>
          {this.showAccountFooter(selectedAccount)}
        </div>
      </div>
    );
  }
}
GRRefuse.propTypes = {};

export default GRRefuse;
